import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';






import {
  Drawer,
  Form,
  Button,
  SelectPicker,
  Message,
  Input,
  InputNumber,
  Toggle,
  Stack
} from 'rsuite';
import { useDispatch } from 'react-redux';
import { addSetting } from '@/services/feature.service';

interface AddLeaveTypeDrawerProps {
  open: boolean;
  onClose: () => void;
  toaster: any;
}

const AddLeaveTypeDrawer: React.FC<AddLeaveTypeDrawerProps> = ({ open, onClose, toaster }) => {
  const dispatch = useDispatch();
  const [formValue, setFormValue] = useState({
    name: 'Leave',
    type: '',
    NBDays: 0,
    NBMonths: 0,
    category: '',
    increment: false,
    Days: '',
    comment: '',
    window: null,
    typeBalance: 'LeaveBalance',
    dateControl: ''
    // attachement: false
  });
  const [formError, setFormError] = useState({});
  const [submitting, setSubmitting] = useState(false);
  const { t } = useTranslation();
  const categoryOptions = [
    { label: t('Exceptional'), value: 'exceptional' },
    { label: t('Regular'), value: 'regular' },
    { label: t('Paid'), value: 'paid' },
    { label: t('Unpaid'), value: 'unpaid' }
  ];
  const dateControlOptions = [
    { label: t('Before'), value: 'before' },
    { label: t('After'), value: 'after' }
  ];
  const daysOptions = [
    { label: t('Business Days'), value: 'businessDay' },
    { label: t('Calendar Days'), value: 'calendarDay' }
  ];

  const handleSubmit = async () => {
    const errors: any = {};
    if (!formValue.type) {
      errors.type = t('Leave type is required');
    }

    if (!formValue.category) {
      errors.category = t('Category is required');
    }
    if (formValue.NBDays !== null && (formValue.NBDays < 0 || formValue.NBDays > 31)) {
      errors.NBDays = t('Number of days must be between 0 and 31');
    }
    if (formValue.NBMonths !== null && (formValue.NBMonths < 0 || formValue.NBMonths > 12)) {
      errors.NBMonths = t('Number of months must be between 0 and 12');
    }

    if (Object.keys(errors).length > 0) {
      setFormError(errors);
      return;
    }

    setSubmitting(true);

    try {
      await dispatch(
        addSetting(
          {
            ...formValue,
            name: 'Leave',
            Increment: formValue.increment,
            // Attachement: formValue.attachement,
            NBDays: formValue.NBDays === null ? 0 : formValue.NBDays,
            NBMonths: formValue.NBMonths === null ? 0 : formValue.NBMonths,
            dateControl: formValue.dateControl || ''
          },
          'Leave'
        )
      );

      toaster.push(
        <Message type="success" duration={3000}>
          {t('Leave Type added successfully!')}
        </Message>,
        { placement: 'topCenter' }
      );

      setFormValue({
        name: 'Leave',
        type: '',
        NBDays: 0,
        NBMonths: 0,
        category: '',
        increment: false,
        Days: '',
        comment: '',
        window: null,
        typeBalance: 'LeaveBalance',
        dateControl: ''
        // attachement: false
      });
      onClose();
    } catch (error) {
      toaster.push(
        <Message type="error" duration={3000}>
          {t('Error adding leave type:')} {t(error.message)}
        </Message>,
        { placement: 'topCenter' }
      );
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Drawer backdrop="static" size="sm" placement="right" onClose={onClose} open={open}>
      <Drawer.Header>
        <Drawer.Title>{t('Add New Leave Type')}</Drawer.Title>
        <Drawer.Actions>
          <Button onClick={handleSubmit} appearance="primary" loading={submitting}>
            {t('Save')}
          </Button>
          <Button onClick={onClose} appearance="subtle">
            {t('Cancel')}
          </Button>
        </Drawer.Actions>
      </Drawer.Header>

      <Drawer.Body>
        <Form
          fluid
          formValue={formValue}
          onChange={value => setFormValue(value)}
          formError={formError}
        >
          <Form.Group>
            <Form.ControlLabel>Leave Type</Form.ControlLabel>
            <Form.Control
              name={t("type")}
              accepter={Input}
              placeholder={t("Enter leave type")}
              block
              errorMessage={formError.type}
            />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>Category</Form.ControlLabel>
            <Form.Control
              name={t("category")}
              accepter={SelectPicker}
              data={categoryOptions}
              searchable={false}
              placeholder={t("Select category")}
              block
              errorMessage={formError.category}
            />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>{t('Number of Days')}</Form.ControlLabel>
            <Form.Control
              name={t("NBDays")}
              accepter={InputNumber}
              min={0}
              max={31}
              placeholder={t("Enter number of days (0-31)")}
              errorMessage={formError.NBDays}
            />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>{t("Number of Months")}</Form.ControlLabel>
            <Form.Control
              name={t("NBMonths")}
              accepter={InputNumber}
              min={0}
              max={12}
              placeholder={t("Enter number of months (0-12)")}
              errorMessage={formError.NBMonths}
            />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>{t('Days Type')}</Form.ControlLabel>
            <Form.Control
              name="Days"
              accepter={SelectPicker}
              data={daysOptions}
              searchable={false}
              placeholder={t("Select days type")}
              block
            />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>{t('Comment')}</Form.ControlLabel>
            <Form.Control
              name={t("comment")}
              accepter={Input}
              placeholder={t("Enter additional comments")}
              block
            />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>{t('Increment')}</Form.ControlLabel>
            <Form.Control
              name="increment"
              accepter={Toggle}
              checked={formValue.increment}
              checkedChildren="Yes"
              unCheckedChildren="No"
            />
            <Form.HelpText>{t('Toggle on if leave days can be accumulated')}</Form.HelpText>
          </Form.Group>

          {/* <Form.Group>
            <Form.ControlLabel>Attachement Required</Form.ControlLabel>
            <Form.Control
              name="attachement"
              accepter={Toggle}
              checked={formValue.attachement}
              checkedChildren="Yes"
              unCheckedChildren="No"
            />
          </Form.Group> */}
          <Form.Group>
            <Form.ControlLabel>{t('Date Control')}</Form.ControlLabel>
            <Form.Control
              name={t("dateControl")}
              accepter={SelectPicker}
              data={dateControlOptions}
              searchable={false}
              placeholder={t("Select date control (Optional)")}
              block
            />
          </Form.Group>

          <Form.Group>
            <Form.ControlLabel>{t('Window Period (Optional)')}</Form.ControlLabel>
            <Form.Control
              name="window"
              accepter={InputNumber}
              min={0}
              placeholder={t("Enter window period in days")}
            />
          </Form.Group>
        </Form>
      </Drawer.Body>
    </Drawer>
  );
};

export default AddLeaveTypeDrawer;
